import { render, staticRenderFns } from "./ChinaMap.vue?vue&type=template&id=974b33aa&scoped=true&"
import script from "./ChinaMap.vue?vue&type=script&lang=js&"
export * from "./ChinaMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974b33aa",
  null
  
)

export default component.exports